import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/app/orchestra")({
  component: Outlet,
  beforeLoad: (context) => {
    if (
      context.context.permittedRoutes.find((x) => {
        return x.route === Route.fullPath
      })
    ) {
      return {
        getTitle: () => context?.context.t && context.context.t("Orchestra"),
      }
    }
  },
})
